import _ from 'lodash';
import { CategoryType, ChangeInterpretation, ShowChangeAs, } from './types/prism';
export const DEFAULT_DECIMAL_PRECISION = 2;
export const CLIENT_STATE_KEYS = {
    roundedNumbers: 'roundedNumbers',
    yAxisShared: 'yAxisShared',
    gridLineConfig: 'gridLineConfig',
    IS_STACKED_AS_PERCENT: 'yAxis.isStackedAsPercent',
    columnProperties: 'columnProperties',
    chartProperties: 'chartProperties',
    axisProperties: 'axisProperties',
    tooltipConfig: 'tooltipConfig',
    dataLabels: 'dataLabels',
    detailedLabels: 'detailedLabels',
    conditionalFormatting: 'conditionalFormatting',
    allLabels: 'allLabels',
    summariesNumberFormatConfig: 'summariesNumberFormatConfig',
    customProps: 'customProps',
    linkedColumns: 'linkedColumns',
    yAxisRange: 'yAxisRange',
    axisType: 'axisType',
    name: 'name',
    format: 'format',
    isOpposite: 'isOpposite',
    dynamicTitle: 'dynamicTitle',
    SYSTEM_SERIES_COLORS: 'systemSeriesColors',
    SERIES_COLORS: 'seriesColors',
    SYSTEM_MULTI_COLOR_SERIES_COLORS: 'systemMultiColorSeriesColors',
    MULTI_COLOR_SERIES_COLORS: 'multiColorSeriesColors',
    pivotState: 'pivotState',
    hidePivotSummaries: 'hidePivotSummaries',
    summaryMode: 'summaryMode',
    summaryFormat: 'summaryFormat',
    useFlatLayout: 'useFlatLayout',
    dataFieldArea: 'dataFieldArea',
    showLegend: 'showLegend',
    legendPosition: 'legendPosition',
    kpiDisplayProperties: 'kpiDisplayProperties',
    kpiColumnProperties: 'kpiColumnProperties',
    isHeatmapOverlayed: 'isHeatmapOverlayed',
    showLinearRegressionLine: 'showLinearRegressionLine',
    markersEnabled: 'markersEnabled',
    visibleSeriesNames: 'visibleSeriesNames',
    axisExtremes: 'axisExtremes',
    gridLines: 'gridLines',
    isZoomed: 'isZoomed',
    mapviewport: 'mapviewport',
    showStackedLabels: 'showStackedLabels',
    showRoundedNumbers: 'showRoundedNumbers',
    isStackedAsPercent: 'isStackedAsPercent',
    stackedAsPercentFormat: 'stackedAsPercentFormat',
    responsiveLayoutDisabled: 'responsiveLayoutDisabled',
    responsiveLayoutPreference: 'responsiveLayoutPreference',
    chartSpecific: 'chartSpecific',
    version: 'version',
    dataSize: 'dataSize',
    customColorSelectorArray: 'customColorSelectorArray',
    answerColumnProperty: 'answerColumnProperty',
    showPivotSummaryPrior: 'showPivotSummaryPrior',
    pivotSummariesState: 'pivotSummariesState',
    handleMissingValues: 'handleMissingValues',
    excludeNullValues: 'excludeNullValues',
};
export var CLIENT_STATE_VERSIONS;
(function (CLIENT_STATE_VERSIONS) {
    CLIENT_STATE_VERSIONS["V2"] = "V2";
    CLIENT_STATE_VERSIONS["V2dot1"] = "V2.1";
    CLIENT_STATE_VERSIONS["V2dot2"] = "V2.2";
    CLIENT_STATE_VERSIONS["V3"] = "V3";
    CLIENT_STATE_VERSIONS["V4"] = "V4";
    CLIENT_STATE_VERSIONS["V4dot1"] = "V4DOT1";
    CLIENT_STATE_VERSIONS["V4dot2"] = "V4DOT2";
})(CLIENT_STATE_VERSIONS || (CLIENT_STATE_VERSIONS = {}));
export const CHART_CLIENT_STATE_LATEST_VERSION = CLIENT_STATE_VERSIONS.V4dot2;
export const DEFAULT_RANGE_PARAMS = {
    __typename: 'RangeParam',
    max: null,
    min: null,
};
export const DEFAULT_GRIDLINES = {
    __typename: 'GridLineProperties',
    xGridlineEnabled: null,
    yGridlineEnabled: null,
};
export const DEFAULT_AXIS_EXTREMES = {
    __typename: 'AxisExtremesProps',
    x: null,
    y: null,
};
export const DEFAULT_PIVOT_STATE = {
    __typename: 'PivotState',
    columnExpandedPaths: [],
    rowExpandedPaths: [],
    fields: [],
};
export const DEFAULT_CHART_COLUMN_PROPERTY_MAP = {
    __typename: 'ChartColumnPropertyMap',
    columnId: null,
    columnProperty: null,
};
export const DEFAULT_CHART_VIZ_PROPERTIES = {
    __typename: 'ChartVizColumnProperties',
    conditionalFormatting: null,
    dataLabels: null,
    handleMissingValues: null,
    excludeNullValues: null,
    customProps: null,
    kpiColumnProperties: null,
};
export const DEFAULT_FORMAT_CONFIG = {
    __typename: 'FormatConfig',
    category: null,
    currencyFormatConfig: null,
    customFormatConfig: null,
    isCategoryEditable: null,
    numberFormatConfig: null,
    percentageFormatConfig: null,
};
export const DEFAULT_CURRENCY_FORMAT_CONFIG = {
    __typename: 'CurrencyFormatConfig',
    decimals: null,
    locale: null,
    removeTrailingZeroes: null,
    toSeparateThousands: null,
    unit: null,
};
export const DEFAULT_PIVOT_SUMMARIES_STATE = {
    __typename: 'PivotSummariesState',
    showRowTotals: null,
    showColumnTotals: null,
    showRowGrandTotals: null,
    showColumnGrandTotals: null,
};
export const DEFAULT_CHART_SPECIFIC = {
    __typename: 'ChartSpecificProperties',
    hidePivotSummaries: null,
    isHeatmapOverlayed: null,
    isStackedAsPercent: null,
    markersEnabled: null,
    pivotState: null,
    stackedAsPercentFormat: null,
    summaryFormat: null,
    summaryMode: null,
    useFlatLayout: null,
    customProps: null,
    dataFieldArea: null,
    showPivotSummaryPrior: null,
    pivotSummariesState: DEFAULT_PIVOT_SUMMARIES_STATE,
};
export const DEFAULT_KPI_DISPLAY_PROPERTIES = {
    __typename: 'KpiDisplayProperties',
    showChange: true,
    showChangeAs: ShowChangeAs.Percent,
    changeInterpretation: ChangeInterpretation.UpwardIsGood,
    kpiDisplayColorArray: [],
    linkChangeColorsWithAnomaly: true,
    showAnalyseChangeCta: true,
};
export const resolveShowAnalyseChangeCta = (kpiDisplayPropertiesValue, legacyCustomPropsValue) => {
    if (kpiDisplayPropertiesValue === true) {
        return true;
    }
    if (kpiDisplayPropertiesValue === false) {
        return legacyCustomPropsValue !== false;
    }
    return legacyCustomPropsValue !== null && legacyCustomPropsValue !== void 0 ? legacyCustomPropsValue : true;
};
export const DEFAULT_CHART_PROPERTIES = {
    __typename: 'ChartProperties',
    allLabels: null,
    axisExtremes: null,
    chartSpecific: DEFAULT_CHART_SPECIFIC,
    dataSize: null,
    gridLines: null,
    isZoomed: null,
    mapviewport: null,
    responsiveLayoutDisabled: null,
    responsiveLayoutPreference: null,
    showLinearRegressionLine: null,
    showStackedLabels: null,
    visibleSeriesNames: [],
    showLegend: null,
    legendPosition: null,
    kpiDisplayProperties: DEFAULT_KPI_DISPLAY_PROPERTIES,
};
export const DEFAULT_PERCENTAGE_FORMAT = {
    ...DEFAULT_FORMAT_CONFIG,
    category: CategoryType.Percentage,
    percentageFormatConfig: {
        __typename: 'PercentageFormatConfig',
        decimals: DEFAULT_DECIMAL_PRECISION,
        removeTrailingZeroes: false,
    },
    isCategoryEditable: false,
};
export const DEFAULT_HEADLINE_VIZ_PROPERTY = {
    __typename: 'HeadlineVizProperties',
    conditionalFormatting: null,
    summariesNumberFormatConfig: null,
};
export const DEFAULT_ANSWER_COLUMN_PROPERTY = {
    __typename: 'AnswerColumnProperty',
    format: null,
    sortConfig: null,
};
export const DEFAULT_NUMBER_FORMAT_CONFIG = {
    __typename: 'NumberFormatConfig',
    decimals: null,
    negativeValueFormat: null,
    removeTrailingZeroes: null,
    toSeparateThousands: null,
    unit: null,
};
export const DEFAULT_CUSTOM_FORMAT_CONFIG = {
    __typename: 'CustomFormatConfig',
    format: null,
};
export const DEFAULT_PERCENTAGE_FORMAT_CONFIG = {
    __typename: 'PercentageFormatConfig',
    decimals: null,
    removeTrailingZeroes: null,
};
export const TABLE_CLIENT_STATE_KEYS = {
    ORDERED_COLUMN_IDS: 'ordered_column_ids',
    WIDTH_STATE: 'widthState',
    WRAP_TABLE_HEADER: 'wrapTableHeader',
    SHOW_TABLE_FOOTER: 'showTableFooter',
    SHOW_GRID_SUMMARY: 'showGridSummary',
    WRAP_COLUMN_TEXT: 'wrapColumnText',
    IS_HIDDEN: 'isHidden',
};
export const DEFAULT_TABLE_COLUMN_PROPERTIES = {
    __typename: 'TableVizColumnProperties',
    conditionalFormatting: null,
    wrapColumnText: null,
    isHidden: null,
};
export const DEFAULT_SUMMARIES_STATE = {
    __typename: 'SummariesState',
    showRowTotals: null,
    showColumnTotals: null,
    showRowGrandTotals: null,
    showColumnGrandTotals: null,
};
export const DEFAULT_TABLE_DISPLAY_PROPERTIES = {
    __typename: 'TableDisplayProperties',
    tableTheme: null,
    tableContentDensity: null,
};
export const DEFAULT_COLOR_PALETTE = {
    __typename: 'ColorPalette',
    colors: [],
};
export const DEFAULT_CHART_DEFAULTS = {
    __typename: 'ChartDefaults',
    colorPalette: null,
};
export const DEFAULT_CHART_LEGEND_PROPERTIES = {
    __typename: 'ChartLegendProperties',
    showLegend: null,
    position: null,
};
export const DEFAULT_DATA_LABEL_FILTER = {
    __typename: 'DataLabelFilter',
    value: null,
    operator: null,
};
export const DEFAULT_CHART_COLUMN_DATA_LABEL_PROPERTIES = {
    __typename: 'ChartColumnDataLabelProperties',
    isVisible: null,
    filter: null,
};
export const DEFAULT_STACK_LABELS_PROPERTIES = {
    __typename: 'StackLabelsProperties',
    isVisible: null,
};
export const DEFAULT_CHART_DATA_LABEL_PROPERTIES = {
    __typename: 'ChartDataLabelProperties',
    allLabels: null,
    stackLabelsProperties: null,
    columnDataLabelProperties: [],
};
export const DEFAULT_REGRESSION_LINE_PROPERTIES = {
    __typename: 'RegressionLineProperties',
    enabled: null,
};
export const DEFAULT_CHART_DISPLAY_PROPERTIES = {
    __typename: 'ChartDisplayProperties',
    summariesState: null,
    regressionLineProperties: null,
    gridLineProperties: null,
};
export const DEFAULT_CHART_AXIS_OVERRIDE_PROPERTIES = {
    __typename: 'ChartAxisProperties',
    isNameVisible: null,
    isLabelVisible: null,
    yAxisRange: null,
};
export const DEFAULT_CHART_COLUMN_OVERRIDE_PROPERTIES = {
    __typename: 'ChartColumnProperties',
    color: null,
    conditionalFormatting: null,
};
export const DEFAULT_CHART_OVERRIDES = {
    __typename: 'ChartOverrides',
    legendProperties: null,
    dataLabelProperties: null,
    axisProperties: [],
    displayProperties: null,
    columnProperties: [],
};
export function getDefaultPropsFromDefaultValues(defaultProps, props) {
    const defaultPropKeys = _.keys(defaultProps);
    const updatedProps = {
        ...defaultProps,
        ..._.pick(props, defaultPropKeys),
    };
    if (_.isEmpty(_.omit(updatedProps, '__typename'))) {
        return null;
    }
    return updatedProps;
}
export function getUpdatedFormatConfig(formatConfig) {
    return formatConfig
        ? {
            ...getDefaultPropsFromDefaultValues(DEFAULT_FORMAT_CONFIG, formatConfig),
            currencyFormatConfig: formatConfig.currencyFormatConfig
                ? {
                    ...getDefaultPropsFromDefaultValues(DEFAULT_CURRENCY_FORMAT_CONFIG, formatConfig.currencyFormatConfig),
                }
                : null,
            numberFormatConfig: formatConfig.numberFormatConfig
                ? {
                    ...getDefaultPropsFromDefaultValues(DEFAULT_NUMBER_FORMAT_CONFIG, formatConfig.numberFormatConfig),
                }
                : null,
            customFormatConfig: formatConfig.customFormatConfig
                ? {
                    ...getDefaultPropsFromDefaultValues(DEFAULT_CUSTOM_FORMAT_CONFIG, formatConfig.customFormatConfig),
                }
                : null,
            percentageFormatConfig: formatConfig.percentageFormatConfig
                ? {
                    ...getDefaultPropsFromDefaultValues(DEFAULT_PERCENTAGE_FORMAT_CONFIG, formatConfig.percentageFormatConfig),
                }
                : null,
        }
        : null;
}
//# sourceMappingURL=client-state-type.js.map